/* tslint:disable */
/* eslint-disable */
/**
 * ELOfleet API Documentation
 * Backend of the ELOfleet fleet management system
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ValidationErrorsKind } from './ValidationErrorsKind';
import {
    ValidationErrorsKindFromJSON,
    ValidationErrorsKindFromJSONTyped,
    ValidationErrorsKindToJSON,
    ValidationErrorsKindToJSONTyped,
} from './ValidationErrorsKind';
import type { AuthError } from './AuthError';
import {
    AuthErrorFromJSON,
    AuthErrorFromJSONTyped,
    AuthErrorToJSON,
    AuthErrorToJSONTyped,
} from './AuthError';
import type { BulkImportError } from './BulkImportError';
import {
    BulkImportErrorFromJSON,
    BulkImportErrorFromJSONTyped,
    BulkImportErrorToJSON,
    BulkImportErrorToJSONTyped,
} from './BulkImportError';

/**
 * 
 * @export
 * @interface ErrorProperties
 */
export interface ErrorProperties {
    /**
     * A human-readable description of the error
     * @type {string}
     * @memberof ErrorProperties
     */
    description: string;
    /**
     * A Tree of validation errors.
     * @type {{ [key: string]: ValidationErrorsKind; }}
     * @memberof ErrorProperties
     */
    details?: { [key: string]: ValidationErrorsKind; } | null;
    /**
     * Bulk import error tree.
     * 
     * This is only ever populated for bulk import request errors.
     * @type {BulkImportError}
     * @memberof ErrorProperties
     */
    bulkImportError?: BulkImportError | null;
    /**
     * Authentication error type
     * @type {AuthError}
     * @memberof ErrorProperties
     */
    authError?: AuthError | null;
}



/**
 * Check if a given object implements the ErrorProperties interface.
 */
export function instanceOfErrorProperties(value: object): value is ErrorProperties {
    if (!('description' in value) || value['description'] === undefined) return false;
    return true;
}

export function ErrorPropertiesFromJSON(json: any): ErrorProperties {
    return ErrorPropertiesFromJSONTyped(json, false);
}

export function ErrorPropertiesFromJSONTyped(json: any, ignoreDiscriminator: boolean): ErrorProperties {
    if (json == null) {
        return json;
    }
    return {
        
        'description': json['description'],
        'details': json['details'] == null ? undefined : (mapValues(json['details'], ValidationErrorsKindFromJSON)),
        'bulkImportError': json['bulkImportError'] == null ? undefined : BulkImportErrorFromJSON(json['bulkImportError']),
        'authError': json['authError'] == null ? undefined : AuthErrorFromJSON(json['authError']),
    };
}

export function ErrorPropertiesToJSON(json: any): ErrorProperties {
    return ErrorPropertiesToJSONTyped(json, false);
}

export function ErrorPropertiesToJSONTyped(value?: ErrorProperties | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'description': value['description'],
        'details': value['details'] == null ? undefined : (mapValues(value['details'], ValidationErrorsKindToJSON)),
        'bulkImportError': BulkImportErrorToJSON(value['bulkImportError']),
        'authError': AuthErrorToJSON(value['authError']),
    };
}

